/* eslint @typescript-eslint/no-var-requires: 0 */
const {
  SUPPORTED_LANGUAGES,
  SUPPORTED_COUNTRIES,
  // eslint-disable-next-line @typescript-eslint/no-require-imports
} = require("../constants/language-and-locales");

const getLocaleParts = (locale) => {
  let lang = null;
  let country = null;

  if (!locale?.match(/[a-z]{2}-[A-Z]{2}/)) {
    return { lang, country };
  }

  const firstSegment = locale.split("-")[0];
  const secondSegment = locale.split("-")[1];

  if (SUPPORTED_LANGUAGES.includes(firstSegment)) {
    lang = firstSegment;
  }

  if (SUPPORTED_COUNTRIES.includes(secondSegment)) {
    country = secondSegment;
  }

  return { lang, country };
};

const getLocaleFromLangAndCountry = (lang, country) => {
  return `${lang}-${country}`;
};

module.exports = {
  getLocaleParts,
  getLocaleFromLangAndCountry,
};
